import { Link } from "react-router-dom";
import type { HelpArticle } from "../lib/types";

interface PrevNextProps {
  prev: HelpArticle | null;
  next: HelpArticle | null;
}

export function PrevNext({ prev, next }: PrevNextProps) {
  if (!prev && !next) return null;

  return (
    <nav className="prev-next" aria-label="Previous and next articles">
      {prev ? (
        <Link to={prev.slug} className="prev-next-link prev-next-prev">
          <span className="prev-next-label">← Previous</span>
          <span className="prev-next-title">{prev.title}</span>
        </Link>
      ) : (
        <span />
      )}
      {next ? (
        <Link to={next.slug} className="prev-next-link prev-next-next">
          <span className="prev-next-label">Next →</span>
          <span className="prev-next-title">{next.title}</span>
        </Link>
      ) : (
        <span />
      )}
    </nav>
  );
}
